export default function RatingFillIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2079_9393)">
        <path
          d="M11.4395 2.87047L12.906 5.82772C13.106 6.23938 13.6393 6.63424 14.0893 6.70985L16.7473 7.15511C18.4471 7.44076 18.8471 8.68416 17.6222 9.91074L15.5558 11.9942C15.2058 12.3471 15.0142 13.0276 15.1224 13.5149L15.7141 16.0941C16.1807 18.1356 15.1058 18.9253 13.3143 17.8583L10.8229 16.3713C10.373 16.1025 9.63142 16.1025 9.17309 16.3713L6.68173 17.8583C4.89859 18.9253 3.81538 18.1272 4.28199 16.0941L4.87359 13.5149C4.98191 13.0276 4.79027 12.3471 4.4403 11.9942L2.37387 9.91074C1.15734 8.68416 1.54896 7.44076 3.24877 7.15511L5.90681 6.70985C6.34843 6.63424 6.8817 6.23938 7.08168 5.82772L8.54817 2.87047C9.34809 1.26583 10.6479 1.26583 11.4395 2.87047Z"
          stroke="#FFC700"
          fill="#FFC700"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2079_9393">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
